export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "mapbox-gl-csp-worker-32119e04c8b9076ecfa6.worker.js");
}
